// Figma: RGM Landing Page > Navbar V2 rail > home
const HomeOutline = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.33 7.42 10 2.5l6.67 4.92v8.33c0 .6-.49 1.08-1.09 1.08H4.42c-.6 0-1.09-.48-1.09-1.08V7.42Z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.5 16.83v-5.25h5v5.25" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
);

export default HomeOutline;
